import { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import { withSnackbar } from "notistack";
import { Logger, toastActions } from "@base-provider";
import SFToast from "./toast";
import { NOTIFICATION_ACTIONS } from "../../constants/notificationTypes";
import { useState } from "react";
import { getReport } from "../../services/reportService";
import { dismissNotification } from "../../services/notificationService";
import { notificationActions } from "../../redux/reducers/notificationReducer";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Notifier = ({
  notifications,
  removeMessage,
  enqueueSnackbar,
  closeSnackbar,
}) => {
  const alertContent = (n) => {
    return (
      <SFToast
        message={n.message}
        onClose={() => {
          closeSnackbar(n.id);
        }}
        severity={n.type}
        onView={openNotificationsPanel}
        actionProps={
          n.actionUrl
            ? {
              label:
                  n.customAction === NOTIFICATION_ACTIONS.NAVIGATE
                    ? t("components.notificationNavigate")
                    : t("components.notificationDownload"),
              onClick: () => handleToastNotificationClick(n),
            }
            : {}
        }
      />
    );
  };

  const [downloadActive, setDownloadActive] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleToastNotificationClick = (n) => {
    switch (n.customAction) {
    case NOTIFICATION_ACTIONS.DOWNLOAD:
      if (!downloadActive) {
        setDownloadActive(n.id);
        getReport(n.actionUrl, n.type).finally((response) => {
          setDownloadActive(null);
          dismissNotification(n.id).then((res) => {
            dispatch(notificationActions.dismissNotification(navigator.id));
          });
        });
      }
      break;
    case NOTIFICATION_ACTIONS.NAVIGATE:
      navigate(n.actionUrl);
      break;
    default:
      break;
    }
  };

  const openNotificationsPanel = () => {
    dispatch(notificationActions.setNotificationPanel(true));
  };

  const getMessageContent = (n) => {
    return alertContent(n);
  };

  useEffect(() => {
    Logger.of("App.Core.Notifier").info({ notifications });
    notifications.forEach((n) => {
      enqueueSnackbar(n.message, {
        key: n.id,
        preventDuplicate: true,
        disableWindowBlurListener: false,
        variant: n.type,
        ...(n.autoHideDuration ? { autoHideDuration: n.autoHideDuration } : {}),
        onClose: (_event, _reason, key) => removeMessage(key),
        content: getMessageContent(n),
      });
    });
  }, [notifications]);

  return null;
};

const mapStateToProps = (store) => ({
  notifications: store.toast.messages,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ removeMessage: toastActions.removeMessage }, dispatch);

export default withSnackbar(
  connect(mapStateToProps, mapDispatchToProps)(Notifier)
);
